import { Link } from "react-router-dom";
import { PageHeader } from "./GenericPage";
import { PAGES } from "./pageConfig";

/*
 * A page of links to related screens (assetTransaction.php, stockMgt.php).
 * Links to pages that haven't been converted yet are shown but marked, instead of leading to "Page not found".
 * links: [[slug, faIcon, label], ...]
 */
export default function Hub({ slug, links }) {
  return (
    <main className="pg" style={{ maxWidth: "62rem" }}>
      <PageHeader slug={slug} />
      <div className="hub-grid">
        {links.map(([to, icon, label]) => {
          const ready = !!PAGES[to];
          const inner = (<><span className="hub-ic"><i className={`fas ${icon}`} /></span><span className="hub-label">{label}</span>
            {!ready && <span className="pill-tag">Not converted yet</span>}</>);
          return ready
            ? <Link key={to} to={`/${to}`} className="hub-card">{inner}</Link>
            : <div key={to} className="hub-card off" aria-disabled="true">{inner}</div>;
        })}
      </div>
    </main>
  );
}
